import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { MatchingState } from "./matching-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class MatchingQuestionStateProtobufSerializer
  implements Api.StateSerializationPlugin<MatchingState> {
  key = {
    id: 15,
    name: { ns: "suspend-data", name: "question-state-matching" },
    format: "protobuf"
  };

  serialize(data: MatchingState): Result<Uint8Array, Api.SerializerError> {
    const message = new MatchingStateProtoMessage({
      conceptIds: data.conceptIds,
      definitionIds: data.definitionIds,
    });

    return ProtobufSerializer.serialize<MatchingStateProtoMessage>(
      message,
      MatchingStateProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<MatchingState, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      MatchingStateProtoMessage
    >(content, MatchingStateProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: MatchingState = {
      conceptIds: message.conceptIds,
      definitionIds: message.definitionIds
    };

    return ok(result);
  }
}

@Type.d("MatchingStateProtoMessage")
class MatchingStateProtoMessage extends Message<MatchingStateProtoMessage> {
  @Field.d(1, "string", "repeated")
  conceptIds: string[];

  @Field.d(2, "string", "repeated")
  definitionIds: string[];
}
